import React from "react";

const BS5_Carousel = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Carousel Component</h2>
      <p>This is the BS5_Carousel component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Carousel;
